import { IApplicationContext } from '../../types/applicationContext';
import { useApplicationContext } from '../../utils/applicationContext';

export const getIsDailyrentOnlineBookingEnabled = (config: IApplicationContext['config']) => {
  return !!config.get<boolean>('Dailyrent.OnlineBookingFrontend.Enabled');
};

// @todo сделаем на нормальных данных, когда будет готов бэк, прогресс тут https://jira.cian.tech/browse/SUT-289
export const useIsDailyrentOnlineBookingEnabled = () => {
  const { config } = useApplicationContext();

  return getIsDailyrentOnlineBookingEnabled(config);
};
